import VSelectVideoSort from './index.vue';

export default {
  install: (Vue) => Vue.component('VSelectVideoSort', VSelectVideoSort),
};
